import './ZoneLegendCarView.css'
import {IConstants} from "../model/B2CInfo";

interface IProps {
    title: string
    icon: string
    selected: boolean
    onClick: Function
    mobile: boolean
    id: string
    constants: IConstants
}

export default function ZoneLegendCarView(props: IProps) {
    let zoneImage = props.constants.zones_images?.find((z) => z.id === props.id)
    if (props.mobile) {
        let cl = `Zones_view_legend_car_view_mobile_img_container ${props.selected ? "Zones_view_legend_car_view_mobile_img_container_selected" : ""}`;
        return <a className="Zones_view_legend_car_view_mobile" onClick={(e) => props.onClick()}>
            <div className={cl}>
                {zoneImage && <img className="Zones_view_legend_car_view_img" src={zoneImage?.image ?? ""}/>}
            </div>
            <div className={`Zones_view_legend_car_view_title_mobile${props.selected ? " Zones_view_legend_car_view_title_mobile_selected" : ""}`}>
                {props.title === "На обычной машине" ? "На обычной": props.title}
            </div>
        </a>
    } else {
        let cl = `Zones_view_legend_car_view_img_container ${props.selected ? "Zones_view_legend_car_view_img_container_selected" : ""}`;
        return <a className="Zones_view_legend_car_view" onClick={(e) => props.onClick()}>
            <div className="Zones_view_legend_car_container">
                <div className={cl}>
                    {zoneImage && <img className={`Zones_view_legend_car_view_img`} src={zoneImage?.image ?? ""}/>}
                </div>
                {props.selected && <div className="Zones_view_legend_car_container_selected"></div>}
            </div>
            <div className="Zones_view_legend_car_view_title">
                {props.title}
            </div>
        </a>
    }
}